import {Injectable} from '@angular/core';
import {catchError, map, Observable, of, tap} from 'rxjs';

import {NetworkHelper} from '../helpers/network.helper';
import {IRefreshResult} from 'src/app/data/interfaces/IAuth';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly hostUrl: string;

  private readonly access_token = 'access_token';
  private readonly refresh_token = 'refresh_token';


  constructor(private networkHelper: NetworkHelper) {
    this.hostUrl = environment.host;
  }

  login(email: string, password: string): Observable<boolean> {
    return this.networkHelper.post(`${this.hostUrl}/auth/login`, {email, password}).pipe(
      tap(
        (result: any) => this.doLoginUser(result.result)),
      map(() => true),
      catchError(error => {
        console.log(error);
        return of(false);
      })
    );
  }


  logOut(): Observable<boolean> {
    return this.networkHelper.post(`${this.hostUrl}/auth/logout`).pipe(
      tap(() => this.doLogoutUser()),
      map(() => true),
      catchError(error => {
        console.log(error.error);
        return of(false);
      })
    );
  }

  refreshToken(): Observable<IRefreshResult> {
    return this.networkHelper.post<IRefreshResult>(`${this.hostUrl}/auth/refresh`, {'refreshToken': this.getRefreshToken()}).pipe(
      tap<IRefreshResult>((result) => {
        this.storeAccessToken(result.result);
      })
    );
  }

  isLoggedIn() {
    return !!this.getAccessToken();
  }

  getAccessToken() {
    return localStorage.getItem(this.access_token);
  }

  private getRefreshToken() {
    return localStorage.getItem(this.refresh_token);
  }

  private storeAccessToken(info: any) {
    localStorage.setItem(this.access_token, info.access_token);
  }

  private storeTokens(tokens: any) {
    localStorage.setItem(this.access_token, tokens.access_token);
    localStorage.setItem(this.refresh_token, tokens.refresh_token);
  }

  private doLoginUser(tokens: any) {
    this.storeTokens(tokens);
  }

  private doLogoutUser() {
    this.removeTokens();
  }

  private removeTokens() {
    localStorage.clear();
  }
}
